(function () {
    'use strict';
    /**
      * Release Version - 0.5.x
      *
      * __Security : 0.4.6 - 28 AUG 2018
      *
      *-------------------------------------------------------- */

    angular.module("lw.security.main", []).
        service("__Security", ['__Utils', __Security]);

    function __Security(__Utils) {

        /**
         * 
         * Decrypt string using RSA with Public Key
         *     
         * @return object
         *-------------------------------------------------------- */
        this.rsaDecrypt = function (encryptedString) {
            return RSA.decrypt(encryptedString, this.getPublicRSA());
        };

        /**
         * 
         * Encrypt string using RSA with Public Key
         *     
         * @return object
         *-------------------------------------------------------- */
        this.rsaEncrypt = function (plainString) {

            return RSA.encrypt(plainString, this.getPublicRSA());
        }
        /**
         * 
         * Encrypt string using AES
         *     
         * @return string
         *-------------------------------------------------------- */
        this.aesEncrypt = function (plainString) {

            return window.btoa(CryptoJS.AES.encrypt(JSON.stringify(plainString),
                this.getToken(), { format: CryptoJSAesJson })
                .toString());
        }

        /**
         * 
         * Decrypt string using AES
         *     
         * @return object
         *-------------------------------------------------------- */
        this.aesDecrypt = function (encryptedString) {

            return JSON.parse(CryptoJS.AES.decrypt(window.atob(encryptedString),
                this.getToken(), { format: CryptoJSAesJson })
                .toString(CryptoJS.enc.Utf8));
        }

        /**
         * 
         * get security token
         *     
         * @return string
         *-------------------------------------------------------- */
        this.getToken = function () {
            return __Utils.getXSRFToken();
        }

        /**
         * 
         * get security token
         *     
         * @return string
         *-------------------------------------------------------- */
        this.getPublicRSA = function () {
            return RSA.getPublicKey(__appImmutables.public_encryption_token);
        }

        /**
         * 
         * get secured form identifier
         *     
         * @return object
         *-------------------------------------------------------- */
        this.getSecurityID = function () {
            return __appImmutables.form_security_id;
        };

        /**
         * Process encrypted data
         *
         * @return void
         *-------------------------------------------------------- */

        this.processSecuredData = function (responseData) {
            if (!responseData || !responseData['__maskedData']) {
                return false;
            } else {
                var splitedValues = (responseData['__maskedData']).split('__==__');
                var splitedValueString = '';
                for (var i = 0; i < splitedValues.length; i++) {
                    if (splitedValues[i]) {
                        splitedValueString += this.rsaDecrypt(splitedValues[i]);
                    }
                }
                return JSON.parse(splitedValueString);
            }

        };

        /**
       * process response data whatever it is secured or not returns decrypted data
       *
       * @return void
       *-------------------------------------------------------- */

        this.processResponseData = function (responseData) {
            var processedData = this.processSecuredData(responseData);
            if (processedData == false) {
                return responseData;
            } else {
                return processedData;
            }
        };
    };

})();
